import React from "react"
import styled from "styled-components"
import {connect} from "react-redux"
import TransitionGroup from "react-transition-group/CSSTransitionGroup"
import {ButtonLink} from "buoy-core"
import * as actions from "../actions"
import { FormattedMessage } from "react-intl"

const EditLink = styled(ButtonLink).attrs({
  color: "neutralDark",
  fontSize: "bodySmall",
})`
  margin-top: 4px;
  opacity: ${props => (props.isLast ? `1` : `0.5`)};
`

const TransitionedEdit = ({show, triggerEdit, isLast, disableTabbing}) => (
  <TransitionGroup
    transitionName="edit-button"
    transitionEnterTimeout={900}
    transitionLeave={false}
    transitionAppear={true}
    transitionAppearTimeout={900}>
    {show ? (
      <EditLink
        className="edit-button"
        onClick={triggerEdit}
        tabIndex={disableTabbing ? "-1" : "0"}
        isLast={isLast}>
        <FormattedMessage id="interview.editing.link" defaultMessage="Edit"/>
      </EditLink>
    ) : null}
  </TransitionGroup>
)

const mapStateToProps = state => ({
  disableTabbing: state.search.active
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  triggerEdit: () => dispatch(actions.triggerEdit(ownProps.index - 1)),
})

const TransitionedEditContainer = connect(mapStateToProps, mapDispatchToProps)(
  TransitionedEdit,
)

export {TransitionedEditContainer as default, TransitionedEdit}



// WEBPACK FOOTER //
// ./assets/interview/components/TransitionedEdit.js